import { render, staticRenderFns } from "./classNewsList.vue?vue&type=template&id=1db24c2b&scoped=true&"
import script from "./classNewsList.vue?vue&type=script&lang=js&"
export * from "./classNewsList.vue?vue&type=script&lang=js&"
import style0 from "./classNewsList.vue?vue&type=style&index=0&id=1db24c2b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db24c2b",
  null
  
)

export default component.exports